import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Badge from "components/bootstrap/Badge";
import { Spinner } from "components/common";
import { useSelectedRows, useModalContext } from "common/contexts";
import { Col, Row, Collapsible, DataWell } from "common/components";
import PackRecsAndDeps from "illuminate/components/content-hub/PackRecsAndDeps";
import { useGetRequirements } from "../../utils";
function Title({
  pack,
  requiredPacks,
  requiredByPacks
}) {
  const { t } = useTranslation("enterprise_illuminate");
  return /* @__PURE__ */ React.createElement(Row, { $justify: "space-between", $align: "center" }, /* @__PURE__ */ React.createElement("span", null, pack.title), requiredPacks.length > 0 && /* @__PURE__ */ React.createElement(Badge, null, t("packs_list.dependencies")), requiredByPacks.length > 0 && /* @__PURE__ */ React.createElement(Badge, null, t("packs_list.requirements")));
}
function PacksList() {
  const { t } = useTranslation("enterprise_illuminate");
  const { fetchingAllPacks, getRequiredPacks, getRequiredByPacks } = useGetRequirements();
  const selectedPacks = useSelectedRows();
  const { entity: actionType } = useModalContext();
  const enablingPacks = actionType === "enable";
  const disableCollapsible = useCallback(
    (pack) => getRequiredPacks(pack).length < 1 && getRequiredByPacks(pack).length < 1 && pack.is_compatible,
    [getRequiredPacks, getRequiredByPacks]
  );
  if (fetchingAllPacks) return /* @__PURE__ */ React.createElement(Spinner, { text: t("packs_list.loading_dependencies") });
  return /* @__PURE__ */ React.createElement(Col, { $gap: 0 }, selectedPacks.filter((pack) => pack.enabled === !enablingPacks || enablingPacks && pack.update_available).map((pack) => /* @__PURE__ */ React.createElement(
    Collapsible,
    {
      key: pack.pack_id,
      title: /* @__PURE__ */ React.createElement(Title, { pack, requiredPacks: getRequiredPacks(pack), requiredByPacks: getRequiredByPacks(pack) }),
      disabled: disableCollapsible(pack)
    },
    /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(
      PackRecsAndDeps,
      {
        requiredByPacks: getRequiredByPacks(pack),
        dependsOnPacks: getRequiredPacks(pack),
        requiredVersions: pack.is_compatible ? [] : pack.version_requirements
      }
    ))
  )));
}
export default PacksList;
